import { render, staticRenderFns } from "./noticePage3.vue?vue&type=template&id=8439290c&scoped=true"
import script from "./noticePage3.vue?vue&type=script&lang=js"
export * from "./noticePage3.vue?vue&type=script&lang=js"
import style0 from "./noticePage3.vue?vue&type=style&index=0&id=8439290c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8439290c",
  null
  
)

export default component.exports